// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: 7BvVw9X4KR
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicDotsImg.module.css"; // plasmic-import: 7BvVw9X4KR/css
import gephipng65428Da8A28284D9De35PngJ3W27WepDyL from "./images/gephipng65428Da8A28284D9De35Png.png"; // plasmic-import: j3W27wepDyL_/picture

createPlasmicElementProxy;

export const PlasmicDotsImg__VariantProps = new Array();

export const PlasmicDotsImg__ArgProps = new Array("dotsImgProp");

const $$ = {};

function PlasmicDotsImg__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          dotsImgProp: {
            src: gephipng65428Da8A28284D9De35PngJ3W27WepDyL,
            fullWidth: 612,
            fullHeight: 612,
            aspectRatio: undefined
          }
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <PlasmicImg__
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      alt={""}
      className={classNames(
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
      displayHeight={"auto"}
      displayMaxHeight={"none"}
      displayMaxWidth={"100%"}
      displayMinHeight={"0"}
      displayMinWidth={"0"}
      displayWidth={"auto"}
      loading={"lazy"}
      src={args.dotsImgProp}
    />
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDotsImg__ArgProps,
          internalVariantPropNames: PlasmicDotsImg__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDotsImg__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDotsImg";
  } else {
    func.displayName = `PlasmicDotsImg.${nodeName}`;
  }
  return func;
}

export const PlasmicDotsImg = Object.assign(
  // Top-level PlasmicDotsImg renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicDotsImg
    internalVariantProps: PlasmicDotsImg__VariantProps,
    internalArgProps: PlasmicDotsImg__ArgProps
  }
);

export default PlasmicDotsImg;
/* prettier-ignore-end */
